import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ConsorsNotesTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    subscriptionIdentifier: string;
};

export const schemaLoanRequestResolver_GetConsorsNotesByLeadId = z.object({
    hasNewConsorsNotes: ConsorsNotesTableDefinitionZod.shape.hasNewConsorsNotes,
    // this is not as strictly typed as possible since we only return values with status === CONSORS_ADD_NOTE_STATUSES.SUCCESS
    notes: ConsorsNotesTableDefinitionZod.shape.notes,
});

export type SchemaLoanRequestResolver_GetConsorsNotesByLeadId = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsNotesByLeadId
>;

export type LoanRequestResolver_GetConsorsNotesByLeadId = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsNotesByLeadId
>;
